module.exports = __webpack_public_path__ + "img/2019-3.7b7a990d.jpg";